module.exports = __webpack_public_path__ + "media/images/start_footer-792c6a1223892009e3c42504e3061d6a.webp";